import React from 'react';
import { NewTravelInsurancePage } from './NewTravelInsurancePage';

const NewInternationalTravelInsurancePageWrapper: React.FC = () => {
  return <NewTravelInsurancePage type='international' />;
};

export default NewInternationalTravelInsurancePageWrapper;
